
import { defineComponent } from "vue";

import BreadCrumb from "@/components/Common/BreadCrumb.vue"
import HeadquartersContent from "./Components/HeadquartersContent.vue";

export default defineComponent({
  name: "HeadquartersPage",
  components: {
    BreadCrumb,
    HeadquartersContent,
  },
});
